import { render } from "./TrafficCell.vue?vue&type=template&id=db61b3a8&scoped=true"
import script from "./TrafficCell.vue?vue&type=script&lang=js"
export * from "./TrafficCell.vue?vue&type=script&lang=js"

import "./TrafficCell.vue?vue&type=style&index=0&id=db61b3a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db61b3a8"]])

export default __exports__